import { ReactNode } from 'react';
import { cssVar, HStack } from '@cad-arc';
import { FR_FOOTER_HEIGHT } from './constants';
import { GenericObject } from '../common/types';

export function FrPageFooter({
    children,
    customStyles,
}: {
    children: ReactNode;
    customStyles?: GenericObject<string | number>;
}) {
    return (
        <HStack
            data-testid="fr-page-footer"
            width="100%"
            minHeight={`${FR_FOOTER_HEIGHT - 1}px`}
            height={`${FR_FOOTER_HEIGHT - 1}px`}
            borderTopWidth="1px"
            borderTopColor="border.default"
            backgroundColor={cssVar('arc.colors.surface.background')}
            px={4}
            spacing={4}
            style={{ marginTop: 0, ...(customStyles ?? {}) }}
        >
            {children}
        </HStack>
    );
}
